import OrderItemShippingCost from './OrderItemShippingCost'

export default OrderItemShippingCost
